// eslint-disable-next-line import/prefer-default-export
export function createQueryUrl(pathname: string, indexName: string, query: string) {
  const param = encodeURIComponent(`${indexName}[query]`);
  const encodedQuery = encodeURIComponent(query);

  return `${pathname}?${param}=${encodedQuery}`;
}
